import React from "react";
import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { SavedView } from "../SavedViewsMenu.types";
import { useUpdateSavedViewHook } from "./UpdateSavedViewDialog.hooks";
import { useTranslation } from "../../../../localization/useTranslation.ts";

export interface UpdateSavedViewDialogProps {
    onClose: () => void;
    onViewUpdated: () => void;
    view: SavedView;
    filterConfiguration: any;
    displayConfiguration: any;
}

function UpdateSavedViewDialog(props: UpdateSavedViewDialogProps) {
    const { translateString } = useTranslation();
    const { viewName, setViewName, showError, onUpdateView, inProgress } = useUpdateSavedViewHook(props);

    return (
        <DotLegalDialog
            onDialogClose={props.onClose}
            header={translateString("editViewName")}
            buttonOkText={translateString("save")}
            onOkClick={onUpdateView}
            okButtonDisabled={!viewName.trim() || inProgress}
            size={"sm"}
            open
        >
            <DotLegalTextField
                label={translateString("viewName")}
                value={viewName}
                onChange={setViewName}
                placeholder={translateString("viewName")}
                autoFocus
                debounce={false}
                errorText={showError ? translateString("nameRequired") : undefined}
            />
        </DotLegalDialog>
    );
}

export default UpdateSavedViewDialog;
